import React from 'react'
import ReactDOM from 'react-dom/client'
import 'maplibre-gl/dist/maplibre-gl.css'
import './styles/theme.css'
import { App } from './App'
import { ThemeProvider } from './theme/ThemeContext'
import { AuthGate } from './lib/ivoAuth'

/* Точка входа консоли ИВО. Обёртка StrictMode помогает выявить побочные эффекты.
 *
 * AuthGate (задача №12) обязателен: консоль живёт за OIDC (Keycloak realm utm),
 * а /app/ раздаётся публично. Пока сессии нет — рисуется форма входа и App()
 * не монтируется вовсе, поэтому опрос источников не лепит десяток 401. */
const container = document.getElementById('root')
if (!container) throw new Error('Не найден корневой элемент #root')

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthGate>
        <App />
      </AuthGate>
    </ThemeProvider>
  </React.StrictMode>,
)